import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { Card } from "@/components/ui/card";
import { Building2, Users, DollarSign, Loader2 } from "lucide-react";

const money = (n) => "$" + (n || 0).toLocaleString();

export default function AgencyOverview() {
  const { switchSubAccount } = useAuth();
  const [data, setData] = useState(null);

  useEffect(() => { api.get("/agency/overview").then(({ data }) => setData(data)); }, []);

  if (!data) return <div className="flex items-center justify-center h-64"><Loader2 className="w-6 h-6 animate-spin text-primary" /></div>;

  return (
    <div className="space-y-8 animate-fade-up">
      <div>
        <p className="text-xs uppercase tracking-[0.18em] text-muted-foreground font-semibold">Agency</p>
        <h1 className="text-3xl sm:text-4xl font-display font-bold tracking-tight mt-1">Portfolio Overview</h1>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
        {[
          { icon: Building2, label: "Sub-accounts", value: data.total_sub_accounts, color: "#6366F1" },
          { icon: Users, label: "Total contacts", value: data.total_contacts, color: "#06B6D4" },
          { icon: DollarSign, label: "Total revenue", value: money(data.total_revenue), color: "#10B981" },
        ].map((k) => (
          <Card key={k.label} className="p-5 bg-card border-border/70">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-xl flex items-center justify-center" style={{ background: `${k.color}22` }}>
                <k.icon className="w-5 h-5" style={{ color: k.color }} />
              </div>
              <div>
                <p className="text-xs uppercase tracking-wider text-muted-foreground font-semibold">{k.label}</p>
                <p className="text-2xl font-display font-bold">{k.value}</p>
              </div>
            </div>
          </Card>
        ))}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {data.sub_accounts.map((s) => (
          <Card key={s.id} onClick={() => switchSubAccount(s.id)}
            data-testid={`agency-sub-card-${s.id}`}
            className="p-6 bg-card border-border/70 cursor-pointer hover:-translate-y-1 transition-transform duration-200 group">
            <div className="flex items-center gap-3 mb-5">
              <div className="w-11 h-11 rounded-xl flex items-center justify-center font-display font-bold text-white"
                style={{ background: s.branding?.primary_color || "#6366F1" }}>
                {s.name[0]}
              </div>
              <div className="min-w-0">
                <p className="font-display font-semibold truncate group-hover:text-primary transition-colors">{s.name}</p>
                <p className="text-xs text-muted-foreground truncate">{s.industry || "—"}</p>
              </div>
            </div>
            <div className="flex items-center justify-between text-sm">
              <div><span className="text-muted-foreground">Contacts </span><span className="font-semibold">{s.contacts}</span></div>
              <div><span className="text-muted-foreground">Revenue </span><span className="font-semibold text-emerald-400">{money(s.revenue)}</span></div>
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
}
